import { ref, computed, onBeforeUnmount } from 'vue';

export function useStopwatch() {
    const stopwatchTime = ref(0);
    const stopwatchInterval = ref(null);

    const formattedStopwatch = computed(() => {
        const ms = stopwatchTime.value;
        const minutes = Math.floor(ms / 60000);
        const seconds = Math.floor((ms % 60000) / 1000);
        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    });

    const startStopwatch = () => {
        const startTime = Date.now() - stopwatchTime.value;
        stopwatchInterval.value = setInterval(() => {
            stopwatchTime.value = Date.now() - startTime;
        }, 100);
    };

    const stopStopwatch = () => {
        if (stopwatchInterval.value) {
            clearInterval(stopwatchInterval.value);
            stopwatchInterval.value = null;
        }
    };

    const resetStopwatch = () => {
        stopStopwatch();
        stopwatchTime.value = 0;
    };

    const getTimeInSeconds = () => {
        return Math.floor(stopwatchTime.value / 1000);
    };

    // Cleanup on unmount
    onBeforeUnmount(() => {
        stopStopwatch();
    });

    return {
        stopwatchTime,
        formattedStopwatch,
        startStopwatch,
        stopStopwatch,
        resetStopwatch,
        getTimeInSeconds
    };
}